export const TransactionType_DiInvoice = 170;
export const TransactionType_DiDebitNote = 171;
export const TransactionType_DiCreditNote = 172;
export const AUDIT_ENTITY_TYPE = 'DiInvoice';
export const NOTIFICATION_MODULE = 22;

export const AUTHORITY_LABEL: Record<number, string> = { 1: 'FBR', 2: 'PRA' };
export const INVOICE_TYPE_LABEL: Record<number, string> = {
  1: 'Sale Invoice',
  2: 'Debit Note',
  3: 'Credit Note',
};
export const STATUS_LABEL: Record<number, string> = {
  1: 'Draft',
  2: 'Validated',
  3: 'Pending',
  4: 'Accepted',
  5: 'Failed',
  6: 'Cancelled',
};
export const REG_TYPE_LABEL: Record<number, string> = {
  1: 'Registered',
  2: 'Unregistered',
};
export const ENV_LABEL: Record<number, string> = { 1: 'Sandbox', 2: 'Production' };

export const DiReferenceKind = {
  Province: 'Province',
  DocType: 'DocType',
  HsCode: 'HsCode',
  Uom: 'Uom',
  HsUom: 'HsUom',
  SaleType: 'SaleType',
  Rate: 'Rate',
  SroSchedule: 'SroSchedule',
  SroItem: 'SroItem',
} as const;

export type DiReferenceKindValue = (typeof DiReferenceKind)[keyof typeof DiReferenceKind];

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
